import { Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { useEffect } from "react"

import { filtersSchema } from "@tfg/types/schemas/products"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import {
  HeaderControlsProvider,
  useHeaderControlsContext,
} from "~/components/contexts/useHeaderControlsContext"
import { usePagination } from "~/components/hooks/usePagination"
import { useProductsQuery } from "~/pages/Brand/Products/List/hooks.ts"
import { ProductsAGECTable } from "~/pages/Brand/Regulations/AGEC/ProductsAGECTable.tsx"

const ProductsAGEC = () => {
  const { filters, setFilters } = useHeaderControlsContext()

  const [debouncedProduct] = useDebouncedValue<string | undefined>(
    filters.search,
    600
  )
  const { setPageBasedPagination, cursorBasedPagination } = usePagination()

  useEffect(() => {
    setPageBasedPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedProduct, setPageBasedPagination])

  const productsQuery = useProductsQuery({
    fetchDataOptions: cursorBasedPagination,
    filters: filtersSchema.parse({ ...filters, search: debouncedProduct }),
  })
  return (
    <Stack>
      <DataFetchWrapper query={productsQuery}>
        {({ data, isFetching }) => (
          <Stack>
            <ProductsAGECTable
              data={data}
              fetchDataOptions={cursorBasedPagination}
              setPagination={setPageBasedPagination}
              filtersValue={filters}
              setFiltersValue={setFilters}
              isFetching={isFetching}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}

export const ProductsAGECWrapper = () => {
  return (
    <HeaderControlsProvider>
      <ProductsAGEC />
    </HeaderControlsProvider>
  )
}
